module.exports = __webpack_public_path__ + "img/qr.2d1cbf57.png";